/**
 * @author shreyas.hande on 6/11/18
 *
 */

import { CONFIG_EVENTS } from '../../constants/events';

export const updateConfig = (config = {}, store) => ({
    type: CONFIG_EVENTS.UPDATE_CONFIG,
    payload: {config, store}
});

export const configUpdated = (config = {}, store) => ({
    type: CONFIG_EVENTS.CONFIG_UPDATED,
    payload: {config, store}
});



// WEBPACK FOOTER //
// ../q-jobs/src/actions/ConfigActions/index.js